var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.groups, function(group) {
      return _c(
        "div",
        { key: group.key, staticClass: "mb-3" },
        [
          _c(
            "div",
            {
              staticClass:
                "expandable-group-header d-flex align-center pa-3 mb-2",
              attrs: {
                role: "button",
                tabindex: "0",
                "aria-expanded": String(_vm.isExpanded(group.key))
              },
              on: {
                click: function($event) {
                  return _vm.toggleExpand(group.key)
                },
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.toggleExpand(group.key)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.toggleExpand(group.key)
                  }
                ]
              }
            },
            [
              _c("icon-svg", {
                staticClass: "mr-2",
                attrs: {
                  name: _vm.isExpanded(group.key)
                    ? "mdi-chevron-up"
                    : "mdi-chevron-down",
                  size: "20"
                }
              }),
              _c(
                "span",
                { staticClass: "text-heading-small-medium text-color-900" },
                [_vm._v(" " + _vm._s(group.title) + " ")]
              ),
              _c("v-spacer"),
              _vm._t(
                "header-right",
                [
                  group.subtitle
                    ? _c("span", { staticClass: "az-text-small mr-4" }, [
                        _vm._v(" " + _vm._s(group.subtitle) + " ")
                      ])
                    : _vm._e(),
                  group.value
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "text-heading-small-medium text-color-900"
                        },
                        [_vm._v(" " + _vm._s(group.value) + " ")]
                      )
                    : _vm._e()
                ],
                { group: group, expanded: _vm.isExpanded(group.key) }
              )
            ],
            2
          ),
          _c("v-expand-transition", [
            _vm.isExpanded(group.key)
              ? _c(
                  "div",
                  [
                    _vm._t(
                      "content",
                      [
                        _c("BaseTable", {
                          attrs: {
                            disableMarginTop: "",
                            headers: _vm.headers,
                            items: group.items || [],
                            "hide-default-footer": "",
                            "items-per-page": (group.items || []).length || 10,
                            dense: "",
                            "no-data-text": "Sem registros."
                          }
                        })
                      ],
                      { group: group, headers: _vm.headers, items: group.items }
                    )
                  ],
                  2
                )
              : _vm._e()
          ])
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }